import { Divider } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ACCESSIBILITY, PET_FRIENDLY } from '@/components/switchback/Icon/assets';
import Icon from '@/components/switchback/Icon/IconComponent';
import Text from '@/components/switchback/Text/Text';

import RequirementItem from './RequirementItem';

interface IRequirementDetailProps {
  petFriendlyValue: boolean;
  accessibleValue: boolean;
  onChangePetFriendly: (isSelected: boolean) => void;
  onChangeAccessible: (isSelected: boolean) => void;
  hidePetFriendly?: boolean;
  isGuestOccupancyAvailable?: boolean;
}

const RequirementDetail: React.FC<IRequirementDetailProps> = ({
  petFriendlyValue,
  accessibleValue,
  onChangeAccessible,
  onChangePetFriendly,
  hidePetFriendly = false,
  isGuestOccupancyAvailable,
}) => {
  const intl = useIntl();
  const labels = {
    accessibility: intl.formatMessage({
      description: 'Guests filter > Accessibility checkbox',
      defaultMessage: 'ADA accessible',
      id: 'hpFUsT',
    }),
    pet: intl.formatMessage({
      description: 'Guests filter > Pet-friendly checkbox',
      defaultMessage: 'Pet-friendly',
      id: 'ZqscfO',
    }),
  };

  return (
    <div className="md:w-2/6">
      {!isGuestOccupancyAvailable && (
        <Text
          type="paragraph"
          className="mt-6 mb-5 text-xs font-bold text-gray-500 uppercase md:mt-0 semiHighlight">
          <FormattedMessage
            defaultMessage="Requirements"
            id="KFXSg9"
            description="Guests filter > reset button"
          />
        </Text>
      )}
      {!hidePetFriendly && (
        <>
          <RequirementItem
            value={petFriendlyValue}
            onChange={onChangePetFriendly}
            label={labels.pet}
            icon={
              <Icon
                className="mr-2 text-gray-700"
                style={{ width: '18px', height: '18px' }}
                name={PET_FRIENDLY}
              />
            }
          />
          {isGuestOccupancyAvailable && <Divider className="mt-4 mb-2 md:hidden" />}
        </>
      )}
      <div className="w-full h-3" />
      <RequirementItem
        value={accessibleValue}
        onChange={onChangeAccessible}
        label={labels.accessibility}
        icon={
          <Icon
            className="mr-2 text-gray-700"
            style={{ width: '18px', height: '18px' }}
            name={ACCESSIBILITY}
          />
        }
      />
    </div>
  );
};

export default RequirementDetail;
